import React, { Component } from "react";
import {
  InputGroup,
  Row,
  Col,
  Button,
  Table
} from "reactstrap";

import Collapsible from 'react-collapsible';
import { reduxForm } from 'redux-form'
import { connect } from 'react-redux';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Pagination from "react-js-pagination";
import * as congNoConstant from './constants'
import * as congNoAction from './actions'
import { storedb } from '../client/storedb'
import DisplayRecordText from "../controls/_DisplayRecordText"
import { currentDate } from "../../lib/common";
import Select from 'react-select';
import ViewThanhToan from './_ViewThanhToan';

class CongNoNhanVien extends Component {
  constructor(props) {
    super(props);
    var dbContext = storedb();
    this.state = {
      store_id: dbContext.getStoreId(),
      tuNgay: currentDate().startOf('month'),
      denNgay: currentDate(),
      item: {},
      list: [],
      total_record: 0,
      totalCo: 0,
      totalNo: 0,
      page: 1,
      per_page: 20,
      keyword: "",
      selectedOptionTinhThanh: null,
      selectedOptionNhanVien: null,
      TinhThanhId: 0,
      NhanVienId: 0,
      modalUpdateThanhToan: false,
      objThanhToan: {}
    };
    this.handleDateChange = this.handleDateChange.bind(this);
  }
  viewThanhToan = (e, obj) => {
    e.preventDefault()
    obj["SoTienThanhToan"] = (obj.No < obj.Co) ? 0 : obj.No - obj.Co
    this.setState({ modalUpdateThanhToan: true, objThanhToan: obj })
  };
  handleCloseThanhToan = () => {
    this.setState({ modalUpdateThanhToan: false })
  };
  handleDateChange(name, e, value) {
    switch (name) {
      case "tuNgay":
        this.setState({ tuNgay: e });
        break;
      case "denNgay":
        this.setState({ denNgay: e });
        break;
    }
  }
  handleSearchChange = (name, e, value) => {
    switch (name) {
      case "keyword":
        this.setState({ keyword: e.target.value });
        break;
      case "maNhanVien":
        this.setState({ maNhanVien: e.target.value });
        break;
      default:
        break;
    }
  }
  handleSelectChange = (name, selectedOption) => {
    if (selectedOption && selectedOption.name == "TinhThanh") {
      this.setState({ selectedOptionTinhThanh: name, TinhThanhId: name.value })
    } else if (selectedOption && selectedOption.name == "NhanVien") {
      this.setState({ selectedOptionNhanVien: name, NhanVienId: name.value })
    } else {
      switch (name) {
        case "loaiCongNo":
          this.setState({ loaiCongNo: selectedOption.target.value })
          break;
        default:
          break;
      }
    }
  }
  handlePageChange = (pageNumber) => {
    let page = parseInt(pageNumber || 1)
    return this.setState({ page }, this.fetchList);
  }

  fetchList(page) {
    const { congNoListRequest } = this.props

    var requestData = {
      storeId: this.state.store_id,
      Loai: this.state.loaiCongNo,
      page: page || this.state.page,
      per_page: this.state.per_page,
      TinhThanhId: this.state.TinhThanhId,
      NhanVienId: this.state.NhanVienId
    }
    return congNoListRequest(requestData)
  }
  exportXls = () => {
    const { reportExportXlsRequest } = this.props

    var requestData = {
      storeId: this.state.store_id,
      NhanVienId: this.state.NhanVienId,
      loai: this.state.loaiCongNo,
      fromDate: this.state.tuNgay ? this.state.tuNgay.format('YYYYMMDD') : '',
      toDate: this.state.denNgay ? this.state.denNgay.format('YYYYMMDD') : '',
      keyword: this.state.keyword,
      TinhThanhId: this.state.TinhThanhId
    };
    return reportExportXlsRequest(requestData, (item) => {
      var dataFile = new Blob([item], {
        type: "application/vnd.ms-excel;charset=UTF-8"
      });
      var fileURL = URL.createObjectURL(dataFile);
      var id = 'dlinkExportCongNo';
      var fileName = "congnonhanvien.xls";
      var link = document.getElementById(id);
      if (link == null) {
        var a = document.createElement('a');
        a.style = "display:none;";
        a.id = "dlinkExportCongNo";
        document.body.appendChild(a);
        link = a;
      }
      var filename = prompt("File name", fileName);
      if (filename) {
        link.href = fileURL;
        link.download = filename;
        link.click();
        link.remove();
      }
    });
  }
  search = () => {
    if (this.props.congNoNhanVien.listRequesting) {
      return false;
    }
    return this.setState({ page: 1 }, () => {
      this.fetchList(1);
    });
  }
  onChangeItem = (itemPerPage) => {
    this.setState({ per_page: itemPerPage }, () => {
      this.search();
    });
  }
  // fetchDvhc = () => {
  //   const { congNoDvhcListRequest } = this.props
  //   var requestData = {};
  //   return congNoDvhcListRequest(requestData);
  // }
  fetchNvkd = () => {
    const { congNoNvkdListRequest } = this.props
    var requestData = {};
    return congNoNvkdListRequest(requestData);
  }
  ThanhToanCongNo = (obj) => {
    this.props.congNoNvUpdateRequest(obj, () => {
      this.handleCloseThanhToan()
      this.search()
    })
  }
  BuildSelectOption(list, type) {
    var options = [];
    if (list && list.length > 0) {
      if (type == "TINHTHANH") {
        options.push({ value: 0, label: '--Tất cả tỉnh thành--', ma: 0 })
        list.map((item) => { options.push({ value: item.TinhThanhId, label: item.Ten, ma: item.Ma }) });
      }
      if (type == "NVKD") {
        options.push({ value: 0, label: '--Tất cả nhân viên--', ma: 0 })
        list.map((item) => { options.push({ value: item.NhanVienId, label: item.TenNhanVien }) });
      }
    }
    return options;
  }
  componentDidMount() {
    // this.fetchDvhc()
    this.fetchNvkd()
    this.fetchList(1);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.congNoNhanVien.type == congNoConstant.CONGNO_NV_LIST_SUCCESS) {
      let { list, item } = nextProps.congNoNhanVien;
      this.setState(
        {
          page: item.page,
          per_page: item.per_page,
          total_record: item.total_record,
          totalCo: item.totalCo,
          totalNo: item.totalNo,
          list: list
        }
      )
    }
    else if (nextProps.congNoNhanVien.type == congNoConstant.CONGNO_NV_DVHC_LIST_SUCCESS) {
      let { listDvhc } = nextProps.congNoNhanVien;
      this.setState({
        listDvhc: this.BuildSelectOption(listDvhc, "TINHTHANH"),
      });
    }
    else if (nextProps.congNoNhanVien.type == congNoConstant.CONGNO_NV_NVKD_LIST_SUCCESS) {
      let { listNvkd } = nextProps.congNoNhanVien;
      this.setState({
        listNvkd: this.BuildSelectOption(listNvkd, "NVKD"),
      });
    }
  }
  render() {
    const {
      list,
      selectedOptionTinhThanh,
      selectedOptionNhanVien,
      listDvhc,
      listNvkd
    } = this.state

    const {
      handleSubmit,
      congNoNhanVien: {
        listRequesting,
        isRequesting,
        errors,
        messages
      },
    } = this.props
    const startIndex = (this.state.page > 0 ? this.state.page - 1 : 0) * this.state.per_page
    return (
      <div className="animated fadeIn">
        <BlockUi tag="div" blocking={listRequesting} >
          <div>
            <Collapsible trigger="Tìm kiếm..." overflowWhenOpen="inherit" open={true}>
              <Row>
                {/* <Col sm="6" className="mb-2">
                  <InputGroup size="md">
                    <Select
                      name="TinhThanh"
                      className="w-100"
                      placeholder="Chọn tỉnh thành"
                      value={selectedOptionTinhThanh}
                      onChange={this.handleSelectChange}
                      options={listDvhc}
                    />
                  </InputGroup>
                </Col> */}
                <Col sm="12" className="mb-2">
                  <InputGroup size="md">
                    <Select
                      name="NhanVien"
                      className="w-100"
                      placeholder="Chọn nhân viên"
                      value={selectedOptionNhanVien}
                      onChange={this.handleSelectChange}
                      options={listNvkd}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Collapsible>
            <div className="w-100 mb-2 mt-2">
              <Button size="md" color="success" className="mr-1" onClick={handleSubmit(this.search)}><i className="fa fa-search"></i> Thống kê</Button>&nbsp;
              <Button size="md" color="primary" className="mr-1" onClick={this.exportXls.bind(this, {})}><i className="fa fa-file-excel-o"></i> Xuất excel</Button>
            </div>
          </div>
          <div className="mt-2 bg-white">
            <div className="w-100">
              <DisplayRecordText
                itemsCountPerPage={this.state.per_page}
                onChangeItem={this.onChangeItem}
              />
              <Table hover responsive className="mb-0 d-sm-table table-sm table-bordered">
                <thead className="thead-default">
                  <tr>
                    <th scope="col" width="20" className="text-center">#</th>
                    <th scope="col" width="200" className="text-center">Tên nhân viên</th>
                    {/* <th scope="col" width="150" className="text-center">Tỉnh thành</th> */}
                    <th scope="col" width="100" className="text-center">Nợ</th>
                    <th scope="col" width="100" className="text-center">Có</th>
                    <th scope="col" width="130" className="text-center">Còn nợ</th>
                    <th scope="col" width="80" className="text-center">Thanh Toán</th>
                    <th scope="col" width="80" className="text-center">Lịch sử</th>
                  </tr>
                </thead>
                <tbody>
                  {list && !!list.length && (
                    list.map((res, idx) => (
                      <tr key={idx + 1}>
                        <td className="text-center">{startIndex + (idx + 1)}</td>
                        <td className="text-left">{res.TenNhanVien}</td>
                        {/* <td className="text-left">{res.TenTinh}</td> */}
                        <td className="text-right">{parseFloat(res.No || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat(res.Co || 0).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-right">{parseFloat((res.No || 0) - (res.Co || 0)).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}</td>
                        <td className="text-center">{res.No > 0 ? <a href='#' className="text-primary font-weigh-bold" onClick={(e) => this.viewThanhToan(e, res)}>Thanh Toán</a> : ''}</td>
                        <td className="text-center"><a href='#' className="text-success font-weigh-bold" onClick={(e) => this.viewThanhToan(e, res.NhanVienId)}>Lịch sử thanh toán</a></td>
                      </tr>
                    ))
                  )}
                </tbody>
                <tfoot>
                  <tr>
                    <th scope="col" colSpan="2" className="text-right">
                      Tổng cộng
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.totalNo.toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {this.state.totalCo.toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" className="text-right">
                      <span className="text-success">
                        {(this.state.totalNo - this.state.totalCo).toLocaleString("vi-VN", { minimumFractionDigits: 0 })}
                      </span>
                    </th>
                    <th scope="col" colSpan="2"></th>
                  </tr>
                </tfoot>
              </Table>
              {this.state.totalRecord > this.state.per_page && (
                <Pagination
                  activePage={this.state.page}
                  itemsCountPerPage={this.state.per_page}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange}
                />
              )}
            </div>
            <div className="clearfix"></div>
          </div>
          <ViewThanhToan item={this.state.objThanhToan}
            isRequesting={isRequesting}
            isOpen={this.state.modalUpdateThanhToan}
            onClose={this.handleCloseThanhToan}
            ThanhToanCongNo={this.ThanhToanCongNo}
            errors={errors}
            messages={messages}
          />
        </BlockUi>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  congNoNhanVien: state.congNoNhanVien,
  client: state.client,
})

const connected = connect(mapStateToProps, {
  congNoListRequest: congNoAction.congNoListRequest,
  reportExportXlsRequest: congNoAction.reportExportXlsRequest,
  congNoDvhcListRequest: congNoAction.congNoDvhcListRequest,
  congNoNvkdListRequest: congNoAction.congNoNvkdListRequest,
  congNoNvUpdateRequest: congNoAction.congNoNvUpdateRequest
})(CongNoNhanVien)

const formed = reduxForm({
  form: 'congNoNhanVien',
})(connected)

export default formed;




// WEBPACK FOOTER //
// ./src/views/CongNoNhanVien/CongNoNhanVien.js